interface Props {
  message: string;
}

export default function SigningComplete({ message }: Props) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-sm border p-8 text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
        </div>
        <h2 className="text-lg font-semibold text-gray-900 mb-2">Signing Complete</h2>
        <p className="text-gray-600">{message}</p>
        <div className="mt-6 text-xs text-gray-400">
          Sarsen Capital Partners - Electronic Signature
        </div>
      </div>
    </div>
  );
}
